import React from 'react'
import { Skeleton } from 'component-library/content/Skeleton/Skeleton'
import { Lima } from 'component-library/collections-new/Lima/Lima'

export const MyHomeSkeleton: React.FC<{}> = () => (
    <React.Fragment>
        <Skeleton count={1} />
        <Lima expectedCards={4} onEvent={() => {}} items={{ loaded: false }} />
    </React.Fragment>
)
